import BasicService from "./BasicService";

class ExpenseService extends BasicService {
    constructor() {
        super();
    }

    //   expense
    deleteExpense(expense) {
        let url = `/expenses/${expense.expenseId}`;
        return this.axios.delete(url, expense).then(request => request.data);
    }
    updateExpense(expense) {
        let url = `/expenses/${expense.expenseId}/transactions/${expense.transactionDto.transactionId}`;
        return this.axios.put(url, expense).then(request => request.data);
    }
    addExpense(expense) {
        let url = `/expenses`;
        return this.axios.post(url, expense).then(request => request.data);
    }
    getExpense(pagination,typeId,reportTitle,type) {
        let url = `/expenses`;
        return this.axios.get(url,{
            params: {
                pagination,
                typeId,
                reportTitle,
                type,
            }
        }).then(request => request.data);
    }

    //   Expense Type
    getExpenseType() {
        let url = `/expensetypes`;
        return this.axios.get(url).then(request => request.data);
    }
    deleteExpenseType(expense) {
        let url = `/expensetypes/${expense.expenseTypeId}`;
        return this.axios.delete(url, expense).then(request => request.data);
    }
    updateExpenseType(expense) {
        let url = `/expensetypes/${expense.expenseTypeId}`;
        return this.axios.put(url, expense).then(request => request.data);
    }
    addExpenseType(expense) {
        let url = `/expensetypes`;
        return this.axios.post(url, expense).then(request => request.data);
    }
}

const expenseService = new ExpenseService();
export default expenseService;